import { useEffect, useState } from "react";
import Button from "../../components/Button";
import EmptyState from "../../components/ui/EmptyState";
import LoadingSpinner from "../../components/ui/LoadingSpinner";
import { apiRequest } from "../../api/client";
import { useToast } from "../../context/ToastContext";

export default function AdminSimpleManager({ title, eyebrow, endpoint, fields, emptyItem, labelField }) {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(emptyItem);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const toast = useToast();

  function load() {
    setLoading(true);
    apiRequest(`${endpoint}?admin=true`, { tokenType: "admin" })
      .then((response) => setItems(response.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }

  useEffect(load, [endpoint]);

  function setField(name, value) {
    setForm((current) => ({ ...current, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    try {
      await apiRequest(editingId ? `${endpoint}/${editingId}` : endpoint, {
        method: editingId ? "PUT" : "POST",
        tokenType: "admin",
        body: form,
      });
      toast?.show(`${title} saved.`);
      setForm(emptyItem);
      setEditingId(null);
      load();
    } catch (err) {
      setError(err.message);
    }
  }

  async function remove(id) {
    if (!window.confirm("Delete this item?")) return;
    await apiRequest(`${endpoint}/${id}`, { method: "DELETE", tokenType: "admin" });
    toast?.show("Item deleted.");
    load();
  }

  return (
    <div className="admin-page">
      <div className="admin-page-head"><div><span className="eyebrow">{eyebrow}</span><h1>{title}</h1></div></div>
      <div className="admin-detail-grid">
        <form className="admin-panel form-card" onSubmit={handleSubmit}>
          <h2>{editingId ? "Edit" : "Add"} {title}</h2>
          {fields.map((field) => field.type === "checkbox" ? (
            <label className="admin-checkbox" key={field.name}>
              <input type="checkbox" checked={Boolean(form[field.name])} onChange={(event) => setField(field.name, event.target.checked)} />
              {field.label}
            </label>
          ) : (
            <label key={field.name}>
              <span>{field.label}</span>
              {field.type === "textarea" ? (
                <textarea rows="5" value={form[field.name] || ""} onChange={(event) => setField(field.name, event.target.value)} />
              ) : (
                <input type={field.type || "text"} value={form[field.name] ?? ""} onChange={(event) => setField(field.name, event.target.value)} />
              )}
            </label>
          ))}
          {error && <p className="form-status error">{error}</p>}
          <Button type="submit">Save</Button>
        </form>
        <section className="admin-panel">
          <h2 style={{marginBottom:"20px"}}>All Items</h2>
          {loading ? <LoadingSpinner /> : !items.length ? <EmptyState title="Nothing here yet" /> : (
            <div className="simple-list">
              {items.map((item) => (
                <article key={item.id}>
                  <div>
                    <strong>{item[labelField]}</strong>
                    <span>{item.active ? "Active" : "Inactive"}</span>
                  </div>
                  <div className="table-actions">
                    <button type="button" onClick={() => {
                      setEditingId(item.id);
                      setForm({ ...emptyItem, ...item });
                    }}>Edit</button>
                    <button type="button" onClick={() => remove(item.id)}>Delete</button>
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
